import { ref } from 'vue'

export const newOrder = ref(0)
